import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Sidebar from './Sidebar';
import TopNav from './TopNav';
import Footer from './Footer';
import { AuthContext } from '../context/AuthContext';
import { userSettingsAPI } from '../api/api';

function MainLayout({ children }) {
  const { user } = useContext(AuthContext);
  const [menuLocation, setMenuLocation] = useState('sidebar'); // Default to sidebar

  useEffect(() => {
    if (user) {
      // Fetch menu location setting
      const fetchMenuLocation = async () => {
        try {
          const response = await userSettingsAPI.getMenuLocation();
          if (response.data.success) {
            const location = response.data.menuLocation || 'sidebar';
            setMenuLocation(location);
          } else {
            setMenuLocation('sidebar');
          }
        } catch (error) {
          // On error, default to sidebar
          setMenuLocation('sidebar');
        }
      };
      fetchMenuLocation();
    }
  }, [user]);

  if (!user) {
    return children;
  }

  // If menu location is 'top', render TopNav with menu and no sidebar
  if (menuLocation === 'top') {
    return (
      <>
        <TopNav showMenu={true} />
        <Container fluid style={{ padding: 0 }}>
          <div style={{ padding: '20px' }}>
            {children}
          </div>
        </Container>
        <Footer />
      </>
    );
  }

  // Default: sidebar layout
  return (
    <>
      <TopNav showMenu={false} />
      <Container fluid style={{ padding: 0 }}>
        <Row style={{ margin: 0 }}>
          <Col md={3} lg={2} style={{ padding: 0 }}>
            <Sidebar />
          </Col>
          <Col md={9} lg={10} style={{ padding: 0 }}>
            {children}
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}

export default MainLayout;
